<template>
    <div class="FieldIndex">
        <div class="content" style="height: 100%;">
            <!-- tabs -->
            <!-- <el-tabs v-model="activeName" class="tab-level-1">
        <el-tab-pane label="字段管理" :lazy="true" name="diyTmp" key="diyTmp"></el-tab-pane>
      </el-tabs> -->
            <!-- 过滤器 -->
            <div class="filterCard">
                <div class="top">
                    <div class="search">
                        <el-input v-model="queryName" class="inline-input" suffix-icon="el-icon-search"
                            placeholder="请输入英文代码/字段名称进行查找" clearable @clear="clearFile" ref="auto"
                            :trigger-on-focus="true" @blur="blurChange($event)"></el-input>
                    </div>
                </div>
                <createTemplate id="step1" ref="createFile" @getList="getList" @setPage="setPage" :editObj="editObj">
                </createTemplate>
            </div>
            <div class="table" id="step2" :class="{diy:activeName === 'diyTmp'}">
                <el-table :data="tableData" stripe style="width: 100%" class="file_table" row-key="id" ref="docsTable"
                    current-row-key="id">
                    <template>
                        <el-table-column prop="dityCode" label="英文代码"></el-table-column>
                        <el-table-column prop="dityName" label="字段名称"></el-table-column>
                        <el-table-column prop="dityNameLlm" label="大模型调优"></el-table-column>
                        <el-table-column prop="categoryNames" label="单证类型" :show-message="false"></el-table-column>
                        <el-table-column prop="" label="创建时间" sortable :sort-method="createSort">
                            <template slot-scope="scope">
                                <template v-if="scope.row.createTime">
                                    <!--                                    <div class="file-time">{{-->
                                    <!--                                        scope.row.createTime && scope.row.createTime!=='-'?-->
                                    <!--                                        scope.row.createTime.split(' ')[0] +' '+ scope.row.createTime.split('')[1].substr(0,5) : scope.row.createTime}}</div>-->
                                    <div class="file-time">{{scope.row.createTime}}</div>
                                </template>
                                <template v-else>
                                    <div class="null">-</div>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="更新时间" sortable :sort-by="['updateTime']">
                            <template slot-scope="scope">
                                <div class="file-time">
                                    {{scope.row.updateTime}}
                                    <!--                                    {{scope.row.updateTime && scope.row.updateTime.split(' ')[0]}}-->
                                    <!--                                    {{scope.row.updateTime && scope.row.updateTime.split(' ')[1].substr(0,5)}}-->
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="操作" width="296">
                            <template slot-scope="scope">
                                <div class="handle">
                                    <a href="javascript:void(0)" class="link" @click.stop="editFile(scope.row)">
                                        编辑
                                    </a>
                                    <a href="javascript:void(0)" @click.stop="deleteFile(scope.row)">
                                        <i class="el-icon-delete" style="font-size:18px;"></i>
                                    </a>
                                </div>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <el-pagination layout="total, prev, pager, next, jumper" :page-size="20" :total="total"
                    :current-page="pageEage" @current-change="pageCurrentChange"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapGetters } from 'vuex'
    import Vue from 'vue'
    import createTemplate from './createTemplate'
    import cont from '@/assets/js/cont'

    export default {
        name: 'FieldIndex',
        props: {},
        data() {
            return {
                tableData: [],
                total: null,
                pageEage: 1,
                currentItem: {},
                selection: [],
                activeName: 'diyTmp',
                queryName: '',
                templateStatus: '',
                templateType: '',
                editObj: {},
                introOption: cont.introOption
            }
        },
        computed: {
            ...mapState(['labelState']),
            ...mapGetters(['roleState', 'localPage', 'demoFlag'])
        },
        components: {
            createTemplate
        },
        watch: {
            'labelState.roleState': {
                handler: function (val, oldVal) {
                    this.getList(this.pageEage)
                },
                deep: true
            },
            demoFlag(v) {
                this.initGuide() // 调用新手引导的方法
            }
        },
        mounted() {
            this.pageEage = this.localPage
            this.getList(this.pageEage)
        },
        destroyed() {
            this.$intro().exit()
        },
        methods: {
            initGuide() {
                if (this.demoFlag) {
                    this.$nextTick(() => {
                        // 绑定标签元素的选择器数组
                        this.introOption.steps = [
                            { title: '新增字段', element: '#step1', intro: `点击可新增字段` },
                            { title: '字段管理', element: '#step2', intro: `如果识别有问题可以进行手动调整，首先可以手动调整需要识别的字段` },
                        ]
                        this.$intro()
                            .setOptions(this.introOption)
                            // 点击结束按钮后执行的事件
                            .oncomplete(() => {
                                console.log('点击结束按钮后执行的事件')
                                this.$store.dispatch('setDemoFlag', false);
                                if (this.$router.query) {
                                    this.$router.query.expprt = false
                                }
                                // bus.$emit('toTeachPage', 2);
                            })
                            // 点击跳过按钮后执行的事件
                            .onexit(() => {
                                console.log('点击跳过按钮后执行的事件')
                                this.$store.dispatch('setDemoFlag', false);
                            })
                            // 确认完毕之后执行的事件
                            .onbeforeexit(() => {
                                console.log('确认完毕之后执行的事件')
                                this.$store.dispatch('setDemoFlag', false);
                            })
                            .start()
                    })
                }
            },
            setPage(v) {
                this.pageEage = v
            },
            pageCurrentChange(x) {
                // console.log(x)
                this.pageEage = x

                this.$store.dispatch('setLocalPage', x)

                this.getList(x, {
                    codeOrName: this.queryName
                })
            },
            getList(page = 1, obj = { categoryIdOrName: this.queryName }) {
                let url = this.$resource.listDityCategoryRelation
                    .replace('{pageNum}', page)
                    .replace('{pageSize}', 20)
                    .replace('{categoryIdOrName}', encodeURIComponent(this.queryName))

                this.$axios({
                    url: url,
                    method: 'post'
                })
                    .then(res => {
                        this.$nextTick(() => {
                            this.total = res && res.data.data.total
                            this.tableData = res.data.data.list
                            this.initGuide()
                        })
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            querySearchAsync(queryString, cb) {
                if (this.queryName === '') {
                    cb([])
                    return
                }

                let url = this.$resource.searchHelp

                this.$axios({
                    url: url,
                    method: 'get',
                    data: {
                        keyword: this.queryName
                    },
                    transformResponse: [
                        function (data) {
                            // 对 data 进行任意转换处理
                            let result = JSON.parse(data)
                            let ary = []
                            if (result) {
                                result.data.forEach(item => {
                                    ary.push({
                                        value: item
                                    })
                                })
                            }
                            return ary
                        }
                    ]
                })
                    .then(res => {
                        let results = res.data
                        cb(results)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            handleSelect(item) {
                this.queryName = item.value
                this.getList(this.pageEage)
            },
            clearFile() {
                this.getList(this.pageEage)
            },
            blurChange(x) {
                this.getList(this.pageEage)
            },
            editFile(item) {
                console.log(item)
                this.editObj = Object.assign({}, item)
                this.$refs.createFile.createFieldClick()
            },
            deleteFile(item) {
                this.currentItem = item
                this.$common.deleteDialog({
                    title: '确认删除该自定义字段吗？',
                    confirm: () => {
                        this.deleteHandle()
                    }
                })
            },
            deleteHandle() {
                let url = this.$resource.removedDictType
                    .replace('{id}', this.currentItem.id)
                    .replace('{dityCode}', encodeURIComponent(this.currentItem.dityCode))
                this.$axios({
                    url: url,
                    method: 'post'
                })
                    .then(res => {
                        console.log(res)
                        if (res.data.msg === 'error') {
                            this.$message.error(res.data.data.msg)
                            return
                        }
                        this.getList(this.pageEage, {
                            codeOrName: this.queryName
                        })
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            createSort(a, b) {
                if (!a.createTime) {
                    return 1
                }
                if (!b.createTime) {
                    return -1
                }
                return a.createTime < b.createTime ? -1 : 1
            }
        }
    }
</script>
<style>
    @import './documentIndex.css';
</style>